/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_StoreInputs */

const en_us2_profile_update_store = /** @type {(inputs: Profile_Update_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There's a new version, but it needs the app to be updated from the store.`)
};

const pt_br2_profile_update_store = /** @type {(inputs: Profile_Update_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há uma versão nova, mas ela precisa que o app seja atualizado na loja.`)
};

const es_419_profile_update_store = /** @type {(inputs: Profile_Update_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay una versión nueva, pero necesita que actualices la app desde la tienda.`)
};

const pt_pt2_profile_update_store = /** @type {(inputs: Profile_Update_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há uma versão nova, mas precisa que a app seja atualizada na loja.`)
};

const fr_fr2_profile_update_store = /** @type {(inputs: Profile_Update_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une nouvelle version existe, mais l'app doit être mise à jour depuis la boutique.`)
};

const de_de2_profile_update_store = /** @type {(inputs: Profile_Update_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es gibt eine neue Version, aber dafür muss die App im Store aktualisiert werden.`)
};

const it_it2_profile_update_store = /** @type {(inputs: Profile_Update_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'è una nuova versione, ma richiede di aggiornare l'app dallo store.`)
};

/**
* | output |
* | --- |
* | "There's a new version, but it needs the app to be updated from the store." |
*
* @param {Profile_Update_StoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_store = /** @type {((inputs?: Profile_Update_StoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_StoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_store(inputs)
	if (locale === "es-419") return es_419_profile_update_store(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_store(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_store(inputs)
	if (locale === "de-DE") return de_de2_profile_update_store(inputs)
	if (locale === "it-IT") return it_it2_profile_update_store(inputs)
	return en_us2_profile_update_store(inputs)
});
export { profile_update_store as "profile.update_store" }